/**
 * 描述：产品管理app左侧导航
 * 日期：2017-7-23
 * 作者：Bai.Zhiming
 */
'use strict';
angular.module('productMgrAppLeftModule', ['leftToolsModule'])
    .directive('productMgrAppLeft', ['productManageMentService', '$q', '$stateParams', '$timeout', '$location', 'modalDialog', 'trsHttpService', 'trsColumnTreeLocationService', 'productMangageMentAppService', 'localStorageService', '$state', function(productManageMentService, $q, $stateParams, $timeout, $location, modalDialog, trsHttpService, trsColumnTreeLocationService, productMangageMentAppService, localStorageService, $state) {
        return {
            restirct: 'A',
            scope: true,
            replace: false,
            templateUrl: './manageConfig/productManageMent/app/left/left_tpl.html',
            link: function($scope, iElm, iAttrs) {
                initStatus();
                initData();

                /**
                 * [initStatus description]初始化状态
                 * @param {[type]} [varname] [description]
                 * @return null [description]
                 */
                function initStatus() {
                    $scope.status = {
                        treeOpts: {
                            nodeChildren: 'CHILDREN',
                            dirSelectable: 'true',
                            allowDeselect: false,
                            templateUrl: '../app/components/htmlTemplates/treeTemplate.html',
                            isLeaf: function(node) {
                                return node.HASCHILDREN == 'false';
                            }
                        },
                        treeExpanded: [],
                        utilBtns: {},
                        // selectedNode: {
                        //     chnlid: 0,
                        //     chnlname: "",
                        //     chnldesc: "",
                        //     doctype: 0
                        // }
                    };
                    $scope.showTree = true;
                    $scope.data = [];
                    initDropDownListBlur();
                }

                /**
                 * [initDropDownListBlur description] 初始化下拉菜单失焦事件
                 * @return {[type]} [description]
                 */
                function initDropDownListBlur() {
                    $('html').unbind('click', myBlur).bind('click', myBlur);

                    function myBlur($event) {
                        var $target = $($event.target);
                        if ($target.parents('.content_nav_select').length === 0) {
                            $timeout(function() {
                                $scope.status.isdownPicShow = false;
                            });
                        }
                    }
                    $scope.$on('$destroy', function() {
                        $('html').unbind('click', myBlur);
                    });
                }

                /**
                 * [initSelectSite description]初始化选中站点
                 * @param {[type]} [varname] [description]
                 * @return null [description]
                 */
                function initSelectSite() {
                    var deffer = $q.defer();
                    var siteId = $stateParams.site;
                    if (angular.isDefined(siteId)) {
                        for (var i = 0; i < $scope.treedata.length; i++) {
                            if ($scope.treedata[i].SITEID === siteId) {
                                $scope.status.selectedApp = angular.copy($scope.treedata[i]);
                                break;
                            }
                        }
                        deffer.resolve();
                    } else {
                        $scope.status.selectedApp = angular.copy($scope.treedata[0]);
                    }
                    return deffer.promise;
                }

                /**
                 * [initData description]初始化数据
                 * @param {[type]} [varname] [description]
                 * @return null [description]
                 */
                function initData() {
                    initAppsiteData().then(function() {
                        return initSelectSite();
                    }).then(function() {
                        getChannelsBySite($scope.status.selectedApp).then(function(data) {
                            $scope.data.channelTreedata = data;
                            positionToChannel();
                        });
                        queryUpHeadline();
                    });
                }

                function initAppsiteData() {
                    var deferred = $q.defer();
                    var params = {
                        'serviceid': 'mlf_appconfig',
                        'methodname': 'queryAppSitesForCloud',
                        'SiteDesc': $location.search().sitedesc,
                        'PAGESIZE': 100
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                        var siteData = data.DATA;
                        for (var i = 0; i < siteData.length; i++) {
                            siteData[i].name = siteData[i].SITEDESC;
                        }
                        siteData.unshift({
                            name: '--请选择站点--'
                        });
                        $scope.treedata = siteData;
                        deferred.resolve();
                    });
                    return deferred.promise;
                }

                /**
                 * [initData description]进入站点
                 * @param {[type]} [varname] [description]
                 * @return null [description]
                 */
                function positionToSite() {
                    var siteId = $location.search().site;
                    for (var i = 0; i < $scope.treedata.length; i++) {
                        if ($scope.treedata[i].SITEID === siteId) {
                            $scope.status.selectedApp = angular.copy($scope.treedata[i]);
                            break;
                        }
                    }
                    $scope.selectApp();
                }

                /**
                 * [initData description]初始化数据
                 * @param {[type]} [varname] [description]
                 * @return null [description]
                 */
                function positionToChannel() {
                    var channelId = $location.search().channel;
                    if (angular.isUndefined(channelId)) {return;}
                    $timeout(function() {
                        var treeData = angular.copy($scope.status.selectedApp);
                        treeData.CHILDREN = angular.copy($scope.data.channelTreedata);
                        trsColumnTreeLocationService.columnTreeLocation(7, $location.search().channel, treeData, $scope.status.selectedNode, $scope.status.treeExpanded, function(tree, array, selectedNode) {
                            $scope.data.channelTreedata = tree.CHILDREN;
                            $scope.status.selectedNode = selectedNode;
                            $scope.showToggle($scope.status.selectedNode).then(function() {
                                $scope.status.treeExpanded.push($scope.status.selectedNode);
                            });
                        });
                    }, 600);
                }

                /**
                 * [getChannelsBySite description]根据站点获取栏目
                 * @return null [description]
                 */
                function getChannelsBySite(node) {
                    var deffer = $q.defer();
                    var params;
                    params = {
                        serviceid: 'mlf_appconfig',
                        methodname: 'queryChannelsBySite',
                        siteid: node.SITEID,
                        platform: 4,
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                        for (var i = 0; i < data.length; i++) {
                            data[i].TOPCHNLID = data[i].CHANNELID;
                            data[i].SITEID = node.SITEID;
                        }

                        /* node.CHILDREN = data;*/
                        deffer.resolve(data);
                    });
                    return deffer.promise;
                }

                /**
                 * [showToggle description]展开APP栏目频道树节点
                 * @return null [description]
                 */
                $scope.showToggle = function(node) {
                    var deffer = $q.defer();
                    if (node.HASCHILDREN == 'true') {
                        getChannelsByChannel(node).then(function() {
                            deffer.resolve();
                        });
                    }
                    return deffer.promise;
                };

                /**
                 * [getChannelsByChannel description]根据父栏目获取栏目
                 * @return null [description]
                 */
                function getChannelsByChannel(node) {
                    var deffer = $q.defer();
                    var paramsChnl;
                    paramsChnl = {
                        serviceid: 'mlf_appconfig',
                        methodname: 'queryChannelsByChannel',
                        channelid: node.CHANNELID,
                        platform: 4,
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), paramsChnl, 'get').then(function(data) {
                        for (var i = 0; i < data.length; i++) {
                            data[i].SITEID = node.SITEID;
                        }
                        deffer.resolve(node);
                        node.CHILDREN = data;
                    });
                    return deffer.promise;
                }

                /**
                 * [selectWebsite description]选择站点
                 * @return null [description]
                 */
                $scope.selectApp = function(item) {
                    $scope.status.selectedApp = !!item ? item : $scope.status.selectedApp;
                    if (angular.isUndefined($scope.status.selectedApp.SITEID)) {
                        $scope.goSiteMgr();
                        return;
                    }
                    $scope.showSelected($scope.status.selectedApp);
                    getChannelsBySite($scope.status.selectedApp).then(function(data) {
                        delete $scope.status.UpHeadline;
                        queryUpHeadline();
                        $scope.data.channelTreedata = data;
                    });
                };

                /**
                 * [showSelected description]选中栏目、频道节点
                 * @param {[sel]} [varname] [description] 节点对象
                 * @return null [description]
                 */
                $scope.showSelected = function(sel) {
                    $scope.status.selectedNode = sel;
                    if (!!sel.CHANNELID) {
                        productMangageMentAppService.getCloumnAccessAuthority(sel.TOPCHNLID).then(function(data) {
                            // 將权限信息存入缓存，用于底部路由区加载使用开始
                            localStorageService.remove('appRightOperType_channel'); // 初始化缓存
                            localStorageService.set('appRightOperType_channel', {
                                type: data.router,
                                data: data.data
                            });
                            // 將权限信息存入缓存，用于底部路由区加载使用结束
                            $state.go('manageconfig.productmanage.app.' + data.router, {
                                channel: sel.CHANNELID,
                                parentchnl: sel.TOPCHNLID,
                                site: sel.SITEID,
                                status: sel.STATUS
                            }, {reload: 'manageconfig.productmanage.app.' + data.router});
                        });
                    } else {
                        productMangageMentAppService.getChannelAccessAuthority(sel.SITEID).then(function(_data) {
                            // 將权限信息存入缓存，用于底部路由区加载使用开始
                            localStorageService.remove('appRightOperType_site'); // 初始化缓存
                            localStorageService.set('appRightOperType_site', { 'type': _data.router, 'data': _data.data });
                            // 將权限信息存入缓存，用于底部路由区加载使用结束
                            var url = 'manageconfig.productmanage.app.' + _data.router;
                            $state.go(url, { site: sel.SITEID, status: sel.STATUS }, {reload: url});
                            // $state.go("manageconfig.productmanage.website." + _data.router);
                        });
                    }
                };

                /**
                 * [goSiteMgr description]进入站点管理
                 * @return null [description]
                 */
                $scope.goSiteMgr = function() {
                    $state.go('manageconfig.productmanage.app.site', { site: undefined }, { reload: true });
                };

                /**
                 * [goChnlMgr description]进入站点管理
                 * @return null [description]
                 */
                $scope.goChnlMgr = function() {
                    if ($scope.status.selectedApp.SITEID) {
                        $scope.showSelected($scope.status.selectedApp);
                        $scope.status.treeExpanded = [];
                    } else {
                        modalDialog.alertType('请先选择站点', '', 'info', false);
                    }
                };

                /** 新增
                 * [queryUpHeadline description] 查询头条栏目
                 * @return {[type]} [description]
                 */
                function queryUpHeadline() {
                    if (angular.isDefined($scope.status.UpHeadline)) {return;}
                    var deffer = $q.defer();
                    var params = {
                        serviceid: 'mlf_appoper',
                        methodname: 'queryTopChnlBySiteID',
                        siteid: $scope.status.selectedApp.SITEID
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                        $scope.status.UpHeadline = data.DATA[0];
                    });
                }

                /** 新增
                 * [addToCommon description] 添加为头条栏目
                 * @param {[object]} [node] [description] 栏目数据
                 * @return {[type]} [description]
                 */
                $scope.addUpHeadline = function(node) {
                    var params = {
                        serviceid: 'mlf_appoper',
                        methodname: 'setUpHeadlineChnl',
                        siteid: $scope.status.selectedApp.SITEID,
                        channelid: node.CHANNELID
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                        delete $scope.status.UpHeadline;
                        queryUpHeadline();
                    });
                };

                /** 新增
                 * [cancelUpHeadline description] 取消设置为头条
                 * @param  {[type]} item [description]
                 * @return {[type]}      [description]
                 */
                $scope.cancelUpHeadline = function(item) {
                    delete $scope.status.UpHeadline;
                    var params = {
                        serviceid: 'mlf_appoper',
                        methodname: 'cancelHeadlineChnl',
                        channelid: item.CHNLID
                    };
                    $('.tooltip-arrow').remove();
                    $('.tooltip-inner').remove(); // tooltip组件的坑
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function() {
                        queryUpHeadline();
                    });
                };

                /** 新增
                 * [UpHeadlineIsSelected description] 
                 * @param {[object]} [UpHeadline] [description] 头条栏目是否选中
                 * @param {string} [platform] [description] 平台
                 * @return {[type]} [description]
                 */
                $scope.UpHeadlineIsSelected = function(UpHeadline, platform) {
                    if ($scope.status.selectedNode) {
                        return UpHeadline.CHNLID === $scope.status.selectedNode.CHANNELID;
                    } else {
                        return false;
                    }
                    
                };
            }
        };
    }]);
